export const PageNotFound = () => {
    return (
        <div>404, erreur page non trouvé
            <button>
                <a href="/">Retour à l'accueil
                </a>
            </button>
        </div>
    )
}